/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EGeofenceDrawingControlShape {
  Circle,
  Rectangle,
  Polygon
}
